import AdvertisingCreatePage from './AdvertisingCreatePage';

export default AdvertisingCreatePage;
